<script setup lang="ts">
import { PhArrowLeft as ArrowLeft, PhArrowRight as ArrowRight, PhCheckCircle as CheckCircle, PhClock as Clock, PhLightbulb as Lightbulb, PhShieldCheck as ShieldCheck } from "@phosphor-icons/vue";
import { computed } from "vue";
import BrandBar from "./BrandBar.vue";
import HomeButton from "./HomeButton.vue";
import { useSessionStore } from "../stores/session";
import type { PlanTimeBudget } from "../types";

const store = useSessionStore();
const plan = store.activePlan!;
const timeBudget = computed<PlanTimeBudget>(() => {
  const value = store.stateAnswers.S02;
  if (value === "10") return "10";
  if (value === "15" || value === "30") return "15";
  return "5";
});
const planContent = computed(() => plan.variants[timeBudget.value]);

async function claimPlan() {
  if (store.syncStatus !== "saved") {
    const saved = await store.syncLatestResult();
    if (!saved) {
      store.toast("结果暂未保存，请检查网络后重试");
      return;
    }
  }
  store.track("claim_plan", { route_code: plan.code });
  store.go("lead");
}
</script>

<template>
  <section class="screen screen--plan">
    <header class="subpage-header">
      <button class="icon-button" aria-label="返回结果" @click="store.go('result')"><ArrowLeft :size="22" weight="bold" /></button>
      <BrandBar compact label="今日工位回血起步方案" />
      <HomeButton />
    </header>

    <div class="plan-hero">
      <p class="eyebrow">优先路线 · {{ plan.name }}</p>
      <h1>{{ planContent.headline }}</h1>
      <p>{{ planContent.reason }}</p>
      <span><Clock :size="18" weight="fill" /> 每天 {{ timeBudget }} 分钟起步</span>
    </div>

    <section class="action-card">
      <div class="section-heading"><span><Lightbulb :size="20" weight="fill" /> 今天就做这 3 件事</span></div>
      <ol>
        <li v-for="(action, index) in planContent.actions" :key="action"><span>{{ index + 1 }}</span><p>{{ action }}</p><CheckCircle :size="21" weight="duotone" /></li>
      </ol>
    </section>

    <p class="plan-notice"><ShieldCheck :size="18" weight="fill" /> {{ planContent.notice }}</p>

    <div class="plan-actions">
      <button class="button button--primary" :disabled="store.syncStatus === 'saving'" @click="claimPlan">
        {{ store.syncStatus === "saving" ? "正在保存完整结果…" : store.syncStatus === "error" ? "重试保存并领取行动卡" : "领取工位回血行动卡" }}
        <ArrowRight v-if="store.syncStatus !== 'saving'" :size="20" weight="bold" />
      </button>
      <p v-if="store.syncStatus === 'error'" class="plan-sync-error" role="alert">完整测试结果尚未保存。保存成功后才会显示二维码，避免轻养师无法查询。</p>
      <p class="plan-action-note">添加轻养师后，可继续获得 3 天行动卡、每日提醒、一次解读和第 3 天状态反馈。</p>
      <button class="text-button" @click="store.go('result')">先回结果页</button>
    </div>
  </section>
</template>
